var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { Currency, InputLabel, Th as BaseTh, Td, TableRow, Table as BaseTable, TableWrapper as BaseTableWrapper, H3 } from '@increasecard/typed-components';
var FIRST_COLUMN_WIDTH = '250px';
var CELL_WIDTH = '160px';
export var TableOuterWrapper = styled(BaseTableWrapper)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 0;\n  width: 100%;\n  position: relative;\n"], ["\n  padding: 0;\n  width: 100%;\n  position: relative;\n"])));
export var TableInnerWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  overflow-x: auto;\n  overflow-y: visible;\n"], ["\n  overflow-x: auto;\n  overflow-y: visible;\n"])));
var COLORS = {
    alert: function (_a) {
        var theme = _a.theme;
        return theme.colorsNew.coral.medium;
    },
    success: function (_a) {
        var theme = _a.theme;
        return theme.colorsNew.increase.regular;
    },
    card: function (_a) {
        var theme = _a.theme;
        return theme.colorsNew.card.dark30;
    },
    taxesRegion: function (_a) {
        var theme = _a.theme;
        return theme.colorsNew.gray.grayLight;
    }
};
var TOTAL_COLORS = {
    alert: function (_a) {
        var theme = _a.theme;
        return theme.colorsNew.coral.sLight;
    },
    success: function (_a) {
        var theme = _a.theme;
        return theme.colorsNew.increase.light;
    },
    card: function (_a) {
        var theme = _a.theme;
        return theme.colorsNew.card.light;
    },
    taxesRegion: function (_a) {
        var theme = _a.theme;
        return theme.colorsNew.gray.grayMedium;
    }
};
export var Th = styled(BaseTh).attrs({ scope: 'column' })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n  font-weight: bold;\n"], ["\n  ", "\n  font-weight: bold;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.typography.inputLabel;
});
export var RowTh = styled(BaseTh).attrs({ scope: 'row' })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: relative;\n  left: 0;\n  background: ", ";\n  /* box-shadow: 0px 9px 9px rgba(24, 32, 38, 0.18); */\n  padding: 0 24px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n"], ["\n  position: relative;\n  left: 0;\n  background: ", ";\n  /* box-shadow: 0px 9px 9px rgba(24, 32, 38, 0.18); */\n  padding: 0 24px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colorsNew.gray.grayLight;
});
export var TotalRowTh = styled(BaseTh).attrs({ scope: 'row' })(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  position: relative;\n  left: 0;\n  background: ", ";\n  padding: 0 24px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  border-top: 3px solid ", ";\n  height: 37px;\n"], ["\n  position: relative;\n  left: 0;\n  background: ", ";\n  padding: 0 24px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  border-top: 3px solid ", ";\n  height: 37px;\n"])), function (_a) {
    var variant = _a.variant;
    return TOTAL_COLORS[variant];
}, function (_a) {
    var variant = _a.variant;
    return TOTAL_COLORS[variant];
});
export var Table = styled(BaseTable)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  table-layout: fixed;\n  width: 100%;\n\n  * {\n    box-sizing: border-box;\n  }\n\n  ", " {\n    height: 37px;\n    border-bottom: 1px solid ", ";\n\n    > ", " {\n      height: 37px;\n      & ", " {\n        color: ", ";\n      }\n    }\n  }\n\n  ", " > ", " {\n    border-bottom: 1px solid ", ";\n  }\n\n  ", ":last-child > ", " {\n    border-bottom-left-radius: 9px;\n    border-bottom: 0;\n    ", " {\n      color: ", ";\n    }\n  }\n\n  ", ":last-child > ", ":last-child {\n    border-bottom-right-radius: 9px;\n    border-bottom: 0;\n  }\n\n  ", ":first-child > ", " {\n    border-top-left-radius: 9px;\n  }\n\n  ", " {\n    width: ", ";\n  }\n  ", ", ", " {\n    width: ", ";\n  }\n"], ["\n  table-layout: fixed;\n  width: 100%;\n\n  * {\n    box-sizing: border-box;\n  }\n\n  ", " {\n    height: 37px;\n    border-bottom: 1px solid ", ";\n\n    > ", " {\n      height: 37px;\n      & ", " {\n        color: ", ";\n      }\n    }\n  }\n\n  ", " > ", " {\n    border-bottom: 1px solid ", ";\n  }\n\n  ", ":last-child > ", " {\n    border-bottom-left-radius: 9px;\n    border-bottom: 0;\n    ", " {\n      color: ", ";\n    }\n  }\n\n  ", ":last-child > ", ":last-child {\n    border-bottom-right-radius: 9px;\n    border-bottom: 0;\n  }\n\n  ", ":first-child > ", " {\n    border-top-left-radius: 9px;\n  }\n\n  ", " {\n    width: ", ";\n  }\n  ", ", ", " {\n    width: ", ";\n  }\n"])), TableRow, function (_a) {
    var theme = _a.theme;
    return theme.colorsNew.gray.grayMedium;
}, RowTh, InputLabel, function (_a) {
    var theme = _a.theme;
    return theme.colorsNew.gray.blackSLight;
}, TotalRowTh, Td, function (_a) {
    var theme = _a.theme;
    return theme.colorsNew.gray.grayMedium;
}, TableRow, TotalRowTh, InputLabel, function (_a) {
    var theme = _a.theme;
    return theme.colorsNew.gray.black;
}, TableRow, Td, TableRow, RowTh, RowTh, FIRST_COLUMN_WIDTH, Td, Th, CELL_WIDTH);
export var TableTotalRow = styled(TableRow)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", " & {\n    height: 37px;\n    border-bottom: 0;\n    border-top: 2px solid ", ";\n  }\n  ", " {\n    background: ", ";\n  }\n"], ["\n  ", " & {\n    height: 37px;\n    border-bottom: 0;\n    border-top: 2px solid ", ";\n  }\n  ", " {\n    background: ", ";\n  }\n"])), Table, function (_a) {
    var variant = _a.variant;
    return COLORS[variant];
}, Td, function (_a) {
    var variant = _a.variant;
    return TOTAL_COLORS[variant];
});
export var TableHeaderTh = styled(RowTh)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  ", "\n  font-weight: bold;\n  text-transform: none;\n  color: ", ";\n  ", " ", " > & {\n    height: 43px;\n  }\n"], ["\n  ", "\n  font-weight: bold;\n  text-transform: none;\n  color: ", ";\n  ", " ", " > & {\n    height: 43px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.typography.H3;
}, function (_a) {
    var variant = _a.variant;
    return COLORS[variant];
}, Table, TableRow);
export var TableHeaderRow = styled(TableRow)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  ", " & {\n    height: 37px;\n    border-bottom: 3px solid ", ";\n  }\n"], ["\n  ", " & {\n    height: 37px;\n    border-bottom: 3px solid ", ";\n  }\n"])), Table, function (_a) {
    var variant = _a.variant;
    return COLORS[variant];
});
export var TableHeaderTotalTh = styled(TableHeaderTh)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  background: ", ";\n"], ["\n  background: ", ";\n"])), function (_a) {
    var variant = _a.variant;
    return TOTAL_COLORS[variant];
});
export function DualHeaderTable() {
    return (React.createElement(TableOuterWrapper, null,
        React.createElement(TableInnerWrapper, null,
            React.createElement(Table, null,
                React.createElement("tbody", null,
                    React.createElement(TableHeaderRow, { variant: "card" },
                        React.createElement(TableHeaderTh, { variant: "card" }, "Presentado"),
                        React.createElement(Th, { rightAligned: true }, "Visa"),
                        React.createElement(Th, { rightAligned: true }, "Mastercard"),
                        React.createElement(Th, { rightAligned: true }, "Amex"),
                        React.createElement(Th, { rightAligned: true }, "Naranja"),
                        React.createElement(Th, { rightAligned: true }, "Cabal"),
                        React.createElement(Th, { rightAligned: true }, "Cordobesa"),
                        React.createElement(Th, { rightAligned: true }, "Nevada"),
                        React.createElement(Th, { rightAligned: true }, "CMR")),
                    React.createElement(TableRow, null,
                        React.createElement(RowTh, null,
                            React.createElement(InputLabel, { as: "div" }, "Debito"),
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 }))),
                    React.createElement(TableRow, null,
                        React.createElement(RowTh, null,
                            React.createElement(InputLabel, { as: "div" }, "Cr\u00E9dito"),
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 }))),
                    React.createElement(TableRow, null,
                        React.createElement(RowTh, null,
                            React.createElement(InputLabel, { as: "div" }, "Cr\u00E9dito en cuotas"),
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 }))),
                    React.createElement(TableHeaderRow, { variant: "alert" },
                        React.createElement(TableHeaderTh, { variant: "alert" },
                            React.createElement(H3, null, "Descontado")),
                        React.createElement(Th, { rightAligned: true }, "Visa"),
                        React.createElement(Th, { rightAligned: true }, "Mastercard"),
                        React.createElement(Th, { rightAligned: true }, "Amex"),
                        React.createElement(Th, { rightAligned: true }, "Naranja"),
                        React.createElement(Th, { rightAligned: true }, "Cabal"),
                        React.createElement(Th, { rightAligned: true }, "Cordobesa"),
                        React.createElement(Th, { rightAligned: true }, "Nevada"),
                        React.createElement(Th, { rightAligned: true }, "CMR")),
                    React.createElement(TableRow, null,
                        React.createElement(RowTh, null,
                            React.createElement(InputLabel, { as: "div" }, "Debito"),
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 }))),
                    React.createElement(TableRow, null,
                        React.createElement(RowTh, null,
                            React.createElement(InputLabel, { as: "div" }, "Cr\u00E9dito"),
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 }))),
                    React.createElement(TableRow, null,
                        React.createElement(RowTh, null,
                            React.createElement(InputLabel, { as: "div" }, "Cr\u00E9dito en cuotas"),
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 }))),
                    React.createElement(TableHeaderRow, { variant: "success" },
                        React.createElement(TableHeaderTh, { variant: "success" },
                            React.createElement(H3, null, "Acreditado")),
                        React.createElement(Th, { rightAligned: true }, "Visa"),
                        React.createElement(Th, { rightAligned: true }, "Mastercard"),
                        React.createElement(Th, { rightAligned: true }, "Amex"),
                        React.createElement(Th, { rightAligned: true }, "Naranja"),
                        React.createElement(Th, { rightAligned: true }, "Cabal"),
                        React.createElement(Th, { rightAligned: true }, "Cordobesa"),
                        React.createElement(Th, { rightAligned: true }, "Nevada"),
                        React.createElement(Th, { rightAligned: true }, "CMR")),
                    React.createElement(TableRow, null,
                        React.createElement(RowTh, null,
                            React.createElement(InputLabel, { as: "div" }, "Total"),
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 })),
                        React.createElement(Td, { rightAligned: true },
                            React.createElement(Currency, { currency: "ARS", value: 123.23 }))))))));
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;
